import React, { Fragment, useRef } from 'react';
import { Link } from 'react-router-dom';

interface UpdateProfileSuccessProps {
  submit: () => void;
}

const UpdateProfileSuccess: React.FC<UpdateProfileSuccessProps> = ({ submit }) => {
  const buttonRef = useRef(null);

  return (
    <>
      <div className="flex justify-center">
        <div className="w-24 h-24 flex items-center justify-center">
          <img
            src="/tada.gif"
            alt="Party Popper"
            className="w-24 h-24"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.onerror = null;
              target.innerHTML = '🎉';
            }}
          />
        </div>
      </div>
      <div className="bg-white max-w-sm">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-black mb-5">You're All Set Up!</h2>
          <div className="mt-2">
            <p className="text-sm text-gray-600 leading-relaxed px-2">
                You'll now receive an email with everything you need, including what to do on the day and when your student's books will arrive. In the meantime, feel free to get familiar with the platform by making your own book in just 5 minutes!
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white pb-2 flex justify-center">
        <Link
          to="/"
          className="flex justify-center items-center  text-base font-sm bg-storyblueSecondLightText text-white rounded-2xl px-8 py-2 shadow-xl font-bold capitalize mt-2"
        >
          Continue
        </Link>
      </div>
    </>
  );
};

export default UpdateProfileSuccess;
